module.exports = __webpack_public_path__ + "img/mygroups.971a8ffc.svg";